// extracted by mini-css-extract-plugin
export default {"container":"style_container__jWkGi","title":"style_title__kpMsT","content":"style_content__xwh7R","image":"style_image__jw-mM","image_wrapper":"style_image_wrapper__j3x6i"};